// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67e1824c","453":"bb8a730f","455":"f7d2570c","692":"3fa7c8f2","946":"0bf19f64"}[chunkId] + ".chunk.js";
};